import { render, staticRenderFns } from "./SystemBarSpace.vue?vue&type=template&id=4c2d0e7a&scoped=true&"
import script from "./SystemBarSpace.vue?vue&type=script&lang=ts&"
export * from "./SystemBarSpace.vue?vue&type=script&lang=ts&"
import style0 from "./SystemBarSpace.vue?vue&type=style&index=0&id=4c2d0e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2d0e7a",
  null
  
)

export default component.exports